/* @flow */
import * as React from 'react';
import { translate } from 'react-i18next';

import { ElectroTooltip } from 'components/ExtendedUiElements/customized';

import styles from './AssetsProjectsCount.module.scss';

export type TypeProps = {
  assetsCount: number | string,
  projectsCount: number | string,
  assetsFilter: string,
  projectsFilter: string,
};

@translate()
export default class AssetsProjectsCount extends React.Component<*> {
  static defaultProps = {
    assetsCount: '-',
    projectsCount: '-',
    assetsFilter: '/assets/id?params=assets',
    projectsFilter: '/projects/id?params=projects',
  };

  render(): React.Element<*> {
    const { assetsCount, projectsCount, t }: TypeProps = this.props;

    return (
      <span className={styles.assetsProjectCount}>
        <ElectroTooltip title={t('general:asset_plural')}>
          <React.Fragment>
            <svg>
              <use xlinkHref="#icon-assets" />
            </svg>
            <span>{assetsCount}</span>
          </React.Fragment>
        </ElectroTooltip>
        <ElectroTooltip title={t('general:project_plural')}>
          <React.Fragment>
            <svg>
              <use xlinkHref="#icon-projects" />
            </svg>
            <span>{projectsCount}</span>
          </React.Fragment>
        </ElectroTooltip>
      </span>
    );
  }
}
